import React, { Component } from "react";
import { Grid, Header, Segment, Transition, Button } from "semantic-ui-react";
import MessageModal from '../../support/MessageModal';
import { googleTracking } from '../../../util';

class GetExcitedConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
      messageModal: false
    };
    this.transitionNext = this.transitionNext.bind(this);
  }

  componentDidMount() {
    this.setState({
      visible: true
    });
    googleTracking({ 'event': 'virtualPageview', 'pageview': '/not-prewired/step7/confirmation' });
  }
  transitionNext() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });
    setTimeout(() => {
      changeStep(10, "fade left")
    }, 400);
  }

  sendUsMessage(e) {
    e.preventDefault();
    this.setState({
      messageModal: true
    })
  }

  closeSendUsMessage() {
    this.setState({
      messageModal: false
    })
  }


  render() {
    const { visible, animation, messageModal } = this.state;
    return (
      <div>
        <Transition visible={visible} duration={500} animation={animation}>
          <div>
            <Header className="title__main" as="h1" textAlign="center">
              We will contact you
            </Header>
            <Grid className="instant-activation width__xs confirmation">
              <Grid.Row className="py-0">
                <Grid.Column className="px-0">
                  <Segment inverted textAlign="center">
                    <div className="circle-tick" />
                    <Header as="h3" className="title" textAlign="center">
                      GET EXCITED
                    </Header>
                    <Segment
                      className="sub__instant-activation ui inverted mx-4"
                      textAlign="center"
                    >
                      <p className="text-white f-size--14">
                        We will contact you within 1-2 business days to schedule
                        your installation.
                      </p>
                    </Segment>
                    <Button
                      secondary
                      className="btn--full text-white"
                      size="medium"
                      onClick={this.transitionNext}
                    >
                      CLOSE
                    </Button>
                  </Segment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="px-4 py-0 learn-more__text">
                <Grid.Column textAlign="center">
                  <p className="itc-std-md f-size--14">
                    Questions?&nbsp;
                    <a className="text-prime" href="#0" onClick={this.sendUsMessage.bind(this)}>Send us a message.</a>
                  </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Transition>
        <MessageModal open={messageModal} closeMessageModal={this.closeSendUsMessage.bind(this)} />

      </div>
    );
  }
}

export default GetExcitedConfirmation;



// WEBPACK FOOTER //
// ./src/components/check-availability/service-available/GetExcitedConfirmation.js